import {key} from "ionicons/icons";

export class Address {
    addressTypeId!: number;
    addressType!: string;
    postCode!: string;
    city!: string;
    streetName!: string;
    streetNumber!: string;
    flatNumber!: string;
    gmina!: string;
    powiat!: string;
    poczta!: string;
    wojewodztwo!: string;
    name!: string;

    showFlatNumber: boolean = true;
    showGmina: boolean = false;
    showPowiat: boolean = false;
    showPoczta: boolean = false;
    showWojewodztwo: boolean = false;

    get isAddressValid(): boolean {
            return (
                this.isPostCodeValid &&
                this.isCityValid &&
                this.isStreetNameValid &&
                this.isStreetNumberValid &&
                (this.isFlatNumberValid || this.showFlatNumber === false) &&
                (this.isWojewodztwoValid || this.showWojewodztwo === false) &&
                (this.isPocztaValid || this.showPoczta === false) &&
                (this.isPowiatValid || this.showPowiat === false) &&
                (this.isGminaValid || this.showGmina === false)
            );
    }
    get isCityValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ-]{1,50}$');
        return this.city != null && rxRule.test((this.city));
    }
    get isCityShowValidator(): boolean {
        return !this.isCityValid && this.city != null && this.city.length > 0;
    }
    get isStreetNameValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ0-9-]{1,50}$');
        return this.streetName != null && rxRule.test((this.streetName));
    }
    get isStreetNameShowValidator(): boolean {
        return !this.isStreetNameValid && this.streetName != null && this.streetName.length > 0;
    }
    get isStreetNumberValid(): boolean {
        const rxRule = new RegExp('^[a-zA-Z0-9]{1,24}$');
        return this.streetNumber != null && rxRule.test((this.streetNumber));
    }
    get isStreetNumberShowValidator(): boolean {
        return !this.isStreetNumberValid && this.streetNumber != null && this.streetNumber.length > 0;
    }
    get isFlatNumberValid(): boolean {
        const rxRule = new RegExp('^[a-zA-Z0-9]{1,24}$');
        return this.flatNumber == null || this.flatNumber.length === 0 || rxRule.test((this.flatNumber));
    }
    get isFlatNumberShowValidator(): boolean {
        return !this.isFlatNumberValid && this.flatNumber != null && this.flatNumber.length > 0;
    }
    get isPostCodeValid(): boolean {
        const rxRule = new RegExp('^[0-9][0-9]-[0-9][0-9][0-9]$');
        return this.postCode != null && rxRule.test(this.postCode);
    }
    get isPostCodeShowValidator(): boolean {
        return !this.isPostCodeValid && this.postCode != null && this.postCode.length > 0;
    }
    get isGminaValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ-]{1,50}$');
        return this.gmina != null && rxRule.test((this.gmina));
    }
    get isGminaShowValidator(): boolean {
        return !this.isGminaValid && this.gmina != null && this.gmina.length > 0;
    }
    get isPowiatValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ-]{1,50}$');
        return this.powiat != null && rxRule.test((this.powiat));
    }
    get isPowiatShowValidator(): boolean {
        return !this.isPowiatValid && this.powiat != null && this.powiat.length > 0;
    }
    get isPocztaValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ-]{1,50}$');
        return this.poczta != null && rxRule.test((this.poczta));
    }
    get isPocztaShowValidator(): boolean {
        return !this.isPocztaValid && this.poczta != null && this.poczta.length > 0;
    }
    get isWojewodztwoValid(): boolean {
        const rxRule = new RegExp('^[a-z ąćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ-]{1,50}$');
        return this.wojewodztwo != null && rxRule.test((this.wojewodztwo));
    }
    get isWojewodztwoShowValidator(): boolean {
        return !this.isWojewodztwoValid && this.wojewodztwo != null && this.wojewodztwo.length > 0;
    }
    constructor(result: any) {
      if (!result) { return; }
      this.addressTypeId = result.addressTypeId;
      this.addressType = result.addressType;
      this.postCode = result.postCode;
      this.city = result.city;
      this.streetName = result.streetName;
      this.streetNumber = result.streetNumber;
      this.flatNumber = result.flatNumber;
      this.gmina = result.gmina;
      this.powiat = result.powiat;
      this.poczta = result.poczta;
      this.wojewodztwo = result.wojewodztwo;
      this.name = result.name;
    }
}
